<template>
  <notification-header-list>
    <template #create>
      <div @click="openItemModal(null)" class="btn btn-sm btn-success ms-auto">Создать топик</div>
    </template>
  </notification-header-list>
  <div v-if="!loaded" class="card card-body p-0 border-top border-top-1 border-gray-200">
    <div class="table-responsive custom-table">
      <table class="table table-hover table-rounded table-striped table-row-dashed fs-7 table-row-gray-300 gy-5 custom-table align-middle mb-0">
        <thead>
        <tr class="fw-bold fs-8 text-gray-400">
          <th>Код</th>
          <th>FCM</th>
          <th>Название (ru-RU)</th>
          <th>Подписчики</th>
          <th>Сортировка</th>
          <th>Активен</th>
          <th class="text-end">Действие</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(item, key) in topics" :key="key">
          <td>{{ item.code }}</td>
          <td>{{ item.fcmTopic }}</td>
          <td>{{ getLocaleValue(item.name, 'ru-RU') }}</td>
          <td>{{ item.subscribers }}</td>
          <td>{{ item.sort }}</td>
          <td>{{ item.active ? 'Да' : 'Нет' }}</td>
          <td class="text-end">
            <div class="d-flex justify-content-end">
              <button type="button" class="btn btn-sm btn-light-primary" @click="openItemModal(item.id)">
                Редактировать
              </button>
            </div>
          </td>
        </tr>
        <tr v-if="!topics || topics.length === 0">
          <td colspan="7" class="text-center py-8 text-gray-500">Список пуст</td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="text-center border-top py-3">
      <div class="btn-group">
        <button class="btn btn-sm btn-light" :disabled="page === 0" @click="goToPage(page - 1)">
          <i class="ki-outline ki-arrow-left"></i>
        </button>
        <button
          v-for="(p, i) in visiblePages"
          :key="i"
          class="btn btn-sm btn-light"
          :class="{
            'text-gray-600': p !== '...' && page !== p,
            'text-success fw-bold': p !== '...' && page === p,
            'btn-disabled text-muted': p === '...'
          }"
          :disabled="p === '...'"
          @click="p !== '...' && goToPage(p)"
        >
          {{ p === '...' ? '...' : p + 1 }}
        </button>
        <button class="btn btn-sm btn-light" :disabled="page === totalPages - 1 || totalPages === 0" @click="goToPage(page + 1)">
          <i class="ki-outline ki-arrow-right"></i>
        </button>
      </div>
    </div>
  </div>
  <div v-else class="card rounded">
    <loader />
  </div>
  <notification-topic-modal
    v-if="showModal"
    :item-data="selectedItem"
    @closeModal="closeModal"
  />
</template>

<script>
import NotificationHeaderList from '@/views/EnergoGoClub/Notifications/NotificationHeaderList'
import NotificationTopicModal from '@/views/EnergoGoClub/Notifications/Topic/NotificationTopicModal'
import Loader from '@/components/Loader.vue'
import { notify } from '@kyvg/vue3-notification'
import axios from 'axios'

const API_BASE = '/notification/api/v2/issuer/topics'

export default {
  name: 'NotificationTopic',
  components: { NotificationHeaderList, NotificationTopicModal, Loader },
  data() {
    return {
      loaded: false,
      topics: [],
      page: 0,
      size: 20,
      totalPages: 1,
      showModal: false,
      selectedItem: null,
    };
  },
  computed: {
    visiblePages() {
      const pages = [];
      const total = this.totalPages;
      const current = this.page;
      if (total <= 7) {
        for (let i = 0; i < total; i++) pages.push(i);
      } else {
        pages.push(0);
        if (current > 3) pages.push('...');
        const start = Math.max(1, current - 1);
        const end = Math.min(total - 2, current + 1);
        for (let i = start; i <= end; i++) pages.push(i);
        if (current < total - 4) pages.push('...');
        pages.push(total - 1);
      }
      return pages;
    },
  },
  mounted() {
    this.getTopics();
  },
  methods: {
    getErrorMessage(err) {
      return err?.response?.data?.errorDescription ?? err?.response?.data?.message ?? err.message;
    },
    getTopics() {
      this.loaded = true;
      axios.get(API_BASE, {
        params: {
          page: this.page,
          size: this.size,
        },
      })
        .then((res) => {
          const payload = res?.data;
          const content = Array.isArray(payload?.content) ? payload.content : [];
          this.topics = content;
          this.page = payload?.pageable?.pageNumber ?? this.page;
          const pageSize = payload?.pageable?.pageSize ?? this.size;
          const totalElements = payload?.pageable?.totalElements ?? payload?.totalElements ?? content.length;
          this.totalPages = Math.max(1, Math.ceil(totalElements / pageSize));
        })
        .catch((err) => {
          notify({
            duration: 7000,
            type: 'error',
            speed: 1000,
            title: 'Ошибка',
            text: this.getErrorMessage(err),
          });
          this.topics = [];
          this.totalPages = 1;
        })
        .finally(() => {
          this.loaded = false;
        });
    },
    openItemModal(id) {
      if (!id) {
        this.selectedItem = null;
        this.showModalWithBootstrap();
        return;
      }
      this.loaded = true;
      axios.get(`${API_BASE}/${id}`)
        .then((res) => {
          this.selectedItem = res?.data || null;
          this.showModalWithBootstrap();
        })
        .catch((err) => {
          notify({
            duration: 7000,
            type: 'error',
            speed: 1000,
            title: 'Ошибка',
            text: this.getErrorMessage(err),
          });
        })
        .finally(() => {
          this.loaded = false;
        });
    },
    showModalWithBootstrap() {
      this.showModal = true;
      setTimeout(() => {
        const modalEl = document.getElementById('notificationTopicModal');
        const modal = new bootstrap.Modal(modalEl);
        modal.show();
      }, 10);
    },
    closeModal(isUpdate) {
      this.showModal = false;
      this.selectedItem = null;
      if (isUpdate) this.getTopics();
    },
    goToPage(newPage) {
      if (newPage >= 0 && newPage < this.totalPages) {
        this.page = newPage;
        this.getTopics();
      }
    },
    getLocaleValue(i18nObj, locale) {
      return i18nObj?.[locale] || '';
    },
  },
}
</script>
